module.exports = __webpack_public_path__ + "static/background-one-d8891353b3fab713cea75d86c07ec004.png";